// Filtrado de contrapartes del clasificador. Lógica pura extraída de
// DashboardClassificator: calcula la visibilidad de cada entrada (devolviendo
// COPIAS, sin mutar el state de Vuex) y los conjuntos de cuentas/categorías en
// uso entre las visibles. La orquestación (commit + estado derivado) queda en la
// vista.

function normalizeStr(str) {
    return str
        ? str.toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase()
        : "";
}

export function computeVisibleEntries(orderedCounterparts, filters) {
    const {
        selectedType,
        searchFilter,
        filterTable,
        filterTableHasAccrual,
        accountFilters,
        categoriesFilter,
        categories,
    } = filters;

    const isAccountFiltersEmpty = accountFilters.length === 0;
    const isCategoriesFilterEmpty = categoriesFilter.length === 0;
    const rawFilter = searchFilter ? searchFilter.trim() : "";
    const filterSearchText = rawFilter ? normalizeStr(rawFilter) : "";

    const entries = orderedCounterparts.map((entry) => {
        let allTextNormalized = entry.allTextNormalized;

        let matchesSearch = true;
        if (filterSearchText) {
            if (!allTextNormalized) {
                allTextNormalized = normalizeStr(entry.allText);
            }
            matchesSearch = allTextNormalized.indexOf(filterSearchText) >= 0;
        }

        const visible = (
            selectedType === "todos" ||
            selectedType === entry.counterpart_type
        ) && matchesSearch &&
        (
            (
                filterTable == "Sin Clasificar" &&
                entry.accounts.length == 0 &&
                entry.classified != entry.tax_document_count
            ) || (
                filterTable == "" && (
                    isAccountFiltersEmpty ||
                    entry.accounts.some(
                        (account) => accountFilters.includes(account.level_3)
                    ) ||
                    entry.doc_accounts.some(
                        (account) => accountFilters.includes(account)
                    )
                ))
        ) && (
            (
                filterTableHasAccrual == "Devengados" &&
                entry.has_accrual
            ) || filterTableHasAccrual == ""
        ) && (
            (
                filterTable == "" && (
                    isCategoriesFilterEmpty ||
                    (entry.calculatedCategories && Object.keys(entry.calculatedCategories).some((key) =>
                        entry.calculatedCategories[key].some(
                            (item) => categoriesFilter.includes(item)
                    )))
                ) ||
                filterTable == "Sin Clasificar"
            )
        );
        return { ...entry, isClassifying: false, allTextNormalized, visible };
    });

    const usedAccountsSet = new Set();
    const usedCategories = {};
    entries.forEach((entry) => {
        if (!entry.visible) {
            return;
        }
        if (entry.accounts && entry.accounts.length > 0) {
            entry.accounts.forEach((account) => usedAccountsSet.add(account.level_3));
        }
        if (entry.doc_accounts && entry.doc_accounts.length > 0) {
            entry.doc_accounts.forEach((account) => usedAccountsSet.add(account));
        }
        if (entry.calculatedCategories) {
            categories.forEach((cat) => {
                if (!entry.calculatedCategories[cat]) {
                    return;
                }
                if (!usedCategories[cat]) {
                    usedCategories[cat] = new Set();
                }
                entry.calculatedCategories[cat].forEach((usedCat) => {
                    usedCategories[cat].add(usedCat);
                });
            });
        }
    });

    const filterCategories = [];
    Object.keys(usedCategories).forEach((key) => {
        usedCategories[key].forEach((cat) => {
            filterCategories.push({ value: cat, level_3: cat, level_2: key });
        });
    });

    return {
        entries,
        usedAccounts: [...usedAccountsSet],
        filterCategories,
    };
}
